<template>
  <v-form ref="form">
    <v-text-field
      v-model="charger.chargerId"
      :label="$t('source-adapters.charger-id')"
      :rules="[rules.required, isUniqueCharger]"
    ></v-text-field>
    <v-text-field
      v-model="charger.tag"
      :label="$t('source-adapters.tag')"
      :rules="[rules.required]"
    ></v-text-field>
    <v-textarea
      v-model="charger.notices"
      :label="$t('source-adapters.notices')"
    ></v-textarea>
  </v-form>
</template>

<script>
import { rules } from "../../../mixins/rules";

export default {
  name: "FormChargerSourceAdapter",
  mixins: [rules],
  props: {
    chargers: {
      default: function() {
        return [];
      }
    },
    charger: {
      default: function() {
        return {};
      }
    },
    successCallback: {
      default: function() {
        return () => {};
      }
    }
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.successCallback(this.charger);
      }
    },
    isUniqueCharger(value) {
      return (
        this.chargers.findIndex(i => i.chargerId === value) === -1 ||
        this.$t("source-adapters.charger-id-should-by-unique")
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.config-error-bag::v-deep .v-input__slot {
  display: none !important;
}
</style>
